import React, { useState } from 'react';
import { EventCard } from '../components/EventCard';
import { Search } from 'lucide-react';
import { PastSpeakers } from '../components/PastSpeakers';

interface Event {
  id: number;
  title: string;
  date: string;
  time: string;
  location: string;
  description: string;
  imageUrl: string;
  timestamp: number;
  stripeLink: string;
}

export const Events = () => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const currentDate = new Date().getTime();

  const allEvents: Event[] = [
    {
      id: 1,
      title: "Eve Ruggieri et Rachid Khimoune",
      date: "20 janvier 2025",
      time: "19:15",
      location: "Lieu sera précisé ultérieurement",
      description: "Une soirée exceptionnelle en compagnie d'Eve Ruggieri et de l'artiste Rachid Khimoune.",
      imageUrl: "https://zupimages.net/up/24/48/p6de.png",
      timestamp: new Date('2025-01-20T19:15:00').getTime(),
      stripeLink: "https://buy.stripe.com/bIYeX6glVaqC6sMaEG"
    }
  ];

  const filteredEvents = allEvents.filter(event => 
    event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    event.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    event.location.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const upcomingEvents = filteredEvents
    .filter(event => event.timestamp >= currentDate)
    .sort((a, b) => a.timestamp - b.timestamp);

  return (
    <div className="bg-gray-50 min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col space-y-6 mb-12">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <h1 className="text-3xl font-bold mb-4 md:mb-0">Nos Événements</h1>
            <div className="relative">
              <input
                type="text"
                placeholder="Rechercher un événement..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            </div>
          </div>
        </div>

        {/* Événements à venir */}
        <section className="mb-12">
          {upcomingEvents.length > 0 ? (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <EventCard {...upcomingEvents[0]} />
              </div>
              <div className="flex items-center justify-center p-4">
                <div className="relative w-full max-w-lg rounded-lg overflow-hidden shadow-lg">
                  <img
                    src="https://zupimages.net/up/24/48/inro.jpeg"
                    alt="Illustration de l'événement"
                    className="w-full h-auto object-contain bg-white p-2"
                  />
                </div>
              </div>
            </div>
          ) : (
            <p className="text-gray-600 text-center py-8">
              Aucun événement à venir pour le moment.
            </p>
          )}
        </section>

        {/* Past Speakers Section */}
        <section>
          <PastSpeakers />
        </section>
      </div>
    </div>
  );
};